const segmentsKeys = {
  module: ['segments'] as const,
  list: () => [...segmentsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) => [...segmentsKeys.list(), filters] as const,
  details: (id: string) => [...segmentsKeys.module, 'details', id] as const,
};

export default segmentsKeys;
